var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file-word",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#0958d9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.53,8.97L13.03,3.47c-.14-.14-.33-.22-.53-.22h-4.5c-1.52,0-2.75,1.23-2.75,2.75v12c0,1.52,1.23,2.75,2.75,2.75h8c1.52,0,2.75-1.23,2.75-2.75V9.5c0-.2-.08-.39-.22-.53Zm-5.28-3.16l2.94,2.94h-2.94v-2.94Zm2.75,13.44H8c-.69,0-1.25-.56-1.25-1.25V6c0-.69,.56-1.25,1.25-1.25h3.75v4.75c0,.41,.34,.75,.75,.75h4.75v7.75c0,.69-.56,1.25-1.25,1.25Zm.22-6.53l-1.5,5c-.09,.3-.37,.52-.69,.53-.01,0-.02,0-.03,0-.31,0-.58-.19-.7-.47l-1.3-3.26-1.3,3.26c-.12,.3-.41,.49-.73,.47-.32-.01-.59-.23-.69-.53l-1.5-5c-.12-.4,.11-.82,.5-.93,.4-.12,.81,.11,.93,.5l.88,2.94,1.2-3.01c.23-.57,1.17-.57,1.39,0l1.2,3.01,.88-2.94c.12-.4,.54-.62,.93-.5,.4,.12,.62,.54,.5,.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWord);
export default __webpack_public_path__ + "static/media/file-word.74a5fac62a4d8d54a2ce746020b9a164.svg";
export { ForwardRef as ReactComponent };